<p-progressSpinner *ngIf="!dashboardMetricSet || !dashboardMetricSet.initialized" [style]="{width: '50px', height: '50px'}" fxFlex="1 1 auto" class="spinner"  animationDuration="2s"></p-progressSpinner>
<div fxLayout="column">
    <div fxFlex="1 1 auto" class='dashboard-metric-type'>
        <span>{{dashboardMetricSet.label}}</span>
    </div>
    <div fxFlex="1 1 auto" fxLayout="row">
        <div class="metric-holder" fxFlex="1 1 100%">
            <div fxLayout="row" *ngIf="dashboardMetricSet && dashboardMetricSet.initialized">
                <div fxFlex="1 1 auto" fxLayout="column">
                    <span fxFlex="1 1 auto" class="dashboard-metric-value-med dashboard-metric-center">{{dashboardMetricSet.values[0] || '--'}}</span>
                    <span fxFlex="1 1 auto" class="dashboard-metric-date">{{dashboardMetricSet.dates[0]}}</span>
                </div>
                <div fxFlex="1 1 auto" fxLayout="column">
                    <span fxFlex="1 1 auto" class="dashboard-metric-value-med dashboard-metric-center">{{dashboardMetricSet.values[1] || '--'}}</span>
                    <span fxFlex="1 1 auto" class="dashboard-metric-date">{{dashboardMetricSet.dates[1]}}</span>
                </div>
            </div>
        </div>
    </div>
</div>